import { render, staticRenderFns } from "./order-refund.component.vue?vue&type=template&id=628cb647"
import script from "./order-refund.component.vue?vue&type=script&lang=js"
export * from "./order-refund.component.vue?vue&type=script&lang=js"
import style0 from "./order-refund.component.vue?vue&type=style&index=0&id=628cb647&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports